import React from 'react'
import { gql } from '@apollo/client'
import type { SelectAsyncProps } from '../Select'
import { SelectAsync } from '../Select/SelectAsync'
import { buildTenantFilter, getTenantOptionLabel } from './tenantSelect.utils'

//region GraphQL query
const tenantOptionsQuery = gql`
  query getTenantOptions($filter: JSON!, $options: JSON) {
    getTenantOptions(filter: $filter, options: $options) {
      _id
      code
      name
    }
  }
`
//endregion

const dataLoadOptions = {
  query: tenantOptionsQuery,
  filter: buildTenantFilter,
  resultFieldName: 'getTenantOptions',
}

export type TenantSelectProps = Omit<SelectAsyncProps, 'filter'>

/**
 * Searches tenants by name or code through `getTenantOptions` (payroll and hauler APIs only). Each option is
 * "Name (CODE)" and carries `{ _id, code, name }`; a view that lists tenants differently passes its own `getOptionLabel`.
 * This component wraps the SelectAsync, any valid react-select props can be used here
 */
export const TenantSelect = (props: TenantSelectProps) => {
  return <SelectAsync {...{ getOptionLabel: getTenantOptionLabel, dataLoadOptions, ...props }} />
}
